// https://apto-api-specs.netlify.app/private/stargateapi#operation/get_signed_payload_key
export default {
	public_key: 'dummy_public_key',
	name: 'dummy_public_key_name',
};
